import { render, staticRenderFns } from "./CxIconValueIndicator.vue?vue&type=template&id=576f875c&"
import script from "./CxIconValueIndicator.vue?vue&type=script&lang=js&"
export * from "./CxIconValueIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports